<!--
     <InputMetricNumber
       :initial_value='23'
       :metric_config='{number_type: 'int', only_positive: true, units: 'kg'}'
       readonly
       required
       @change="handler(value)"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid
-->

<template>
  <v-text-field
    v-model="input_value"
    :label="metric_config.units || $vuetify.lang.translator('labels.number')"
    :class="[readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input', { required: required }]"
    :placeholder="metric_config.units || '0'"
    :readonly="readonly"
    @click:append="increment"
    @click:prepend="decrement"
    @change="emit_change"
    outlined
    dense
    background-color="#f2f2f2"
    :disabled="readonly"
    :rules="[only_nums, is_required, check_positive]"
  >
    <template slot="append-outer" v-if="!readonly">
      <v-icon
        @click="increment"
        color="primary"
        :disabled="readonly"
      >
        {{ false || 'mdi-plus' }}
      </v-icon>
    </template>

    <template slot="prepend" v-if="!readonly">
      <v-icon
        color="primary"
        @click="decrement"
        :disabled="readonly"
      >
        {{ false || 'mdi-minus' }}
      </v-icon>
    </template>
  </v-text-field>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";
</style>

<script>
 export default {
   name: 'InputMetricNumber',

   props: {
     metric_config: {required: true},
     initial_value: {required: false, default: null},
     readonly: {required: false, default: false},
     required: {required: false, default: false},
   },

   data: () => ({
     input_value: null,
   }),

   mounted() {
     this.pull_value(this.initial_value);
   },

   computed: {
     value() {
       return +this.input_value;
     },
   },

   methods: {
     validate() {
       return true; // TODO
     },

     pull_value(val) {
       this.input_value = val;
     },

     increment() {
       this.input_value = (+this.input_value) + 1;
     },

     decrement() {
       this.input_value = (+this.input_value) - 1;
       if (this.metric_config.only_positive && this.input_value < 0) {
         this.input_value = 0;
       }
     },

     // Validate functions
     is_required(value) {
       if (value === 0)
         return true;
       return !!value || !this.required || this.$vuetify.lang.translator('required_field');
     },

     only_nums(value) {
       return !isNaN(value) || this.$vuetify.lang.translator('invalid_value');
     },

     check_positive(value) {
       return (!this.only_positive
            || (this.only_positive && this.input_value >= 0)
            || this.$vuetify.lang.translator('invalid_negative_number'));
     },

     emit_change(val) {
       val = +(val !== undefined ? val : this.input_value);
       this.$emit('change', +val);
     },
   },

   watch: {
     input_value(val) {
       this.emit_change(val);
     },

     initial_value(val) {
       this.pull_value(val);
     },
   }
 };
</script>
